export const NAV_LINK = {
    MAIN: 'Модификации', // 'Главная'
    NEWS: 'Новости',
    SUBSCRIPTIONS: 'Мои подписки',
    MODDER_SECTION: 'Раздел мододела',
    ADMIN_SECTION: 'Панель администратора',
    MODERATOR_SECTION: 'Панель модератора',
}
